import { Types, theme } from '@fiverr-private/theme';
import { RING_PADDING } from '../styles';
import { AvatarProps } from '../types';
import { RING_STROKE_WIDTH } from '../constants';
import { AvatarAnimationProps } from './types';

export const generatedSquarePath = (baseAvatarSize: number, borderRadius: Types.BorderRadiuses) => {
    const halfSize = baseAvatarSize / 2;
    const halfStrokeWidth = RING_STROKE_WIDTH / 2;

    const squareBorderRadius =
        parseInt(theme.borderRadiuses[borderRadius], 10) + parseInt(theme.spacing[RING_PADDING], 10) + halfStrokeWidth;

    return `
    M${halfSize},${halfStrokeWidth}
    H${baseAvatarSize - halfStrokeWidth - squareBorderRadius}
    Q${baseAvatarSize - halfStrokeWidth},${halfStrokeWidth} ${baseAvatarSize - halfStrokeWidth},${
        halfStrokeWidth + squareBorderRadius
    }
    V${baseAvatarSize - halfStrokeWidth - squareBorderRadius}
    Q${baseAvatarSize - halfStrokeWidth},${baseAvatarSize - halfStrokeWidth} ${
        baseAvatarSize - halfStrokeWidth - squareBorderRadius
    },${baseAvatarSize - halfStrokeWidth}
    H${halfStrokeWidth + squareBorderRadius}
    Q${halfStrokeWidth},${baseAvatarSize - halfStrokeWidth} ${halfStrokeWidth},${
        baseAvatarSize - halfStrokeWidth - squareBorderRadius
    }
    V${halfStrokeWidth + squareBorderRadius}
    Q${halfStrokeWidth},${halfStrokeWidth} ${halfStrokeWidth + squareBorderRadius},${halfStrokeWidth}
    H${halfSize}
    Z
  `;
};

export const getPerimeter = (baseAvatarSize: number, shape: AvatarProps['shape']): number => {
    if (shape === 'circle') {
        const radius = baseAvatarSize / 2;
        const circlePerimeter = 2 * Math.PI * radius;

        return circlePerimeter;
    }
    const squareSides = 4;
    const strokeOffset = 8;
    const squarePerimeter = squareSides * baseAvatarSize - strokeOffset;

    return squarePerimeter;
};

export const getCircleAttributes = (
    baseAvatarSize: number,
    borderRadius: Types.BorderRadiuses,
    perimeter: number,
    isLoading: AvatarAnimationProps['isLoading']
) => {
    const radius = theme.borderRadiuses[borderRadius];
    const offsetX = 1;
    const offsetY = 1;
    const adjustedSize = baseAvatarSize - offsetX - offsetY;
    const base = {
        width: adjustedSize,
        height: adjustedSize,
        x: offsetX,
        y: offsetY,
        rx: radius,
        ry: radius,
    };
    if (isLoading) {
        return { ...base, strokeWidth: 1 };
    }
    return {
        ...base,
        strokeDasharray: perimeter,
        strokeWidth: RING_STROKE_WIDTH,
    };
};
